import _classCallCheck from "/home/jenkins/jenkins_slave/workspace/build_webui_prod/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "/home/jenkins/jenkins_slave/workspace/build_webui_prod/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/createClass";
import _inherits from "/home/jenkins/jenkins_slave/workspace/build_webui_prod/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/inherits";
import _createSuper from "/home/jenkins/jenkins_slave/workspace/build_webui_prod/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/createSuper";

/*
All material copyright ESRI, All Rights Reserved, unless otherwise specified.
See https://js.arcgis.com/4.22/esri/copyright.txt for details.
*/
import { _ as e } from "../../chunks/tslib.es6.js";
import s from "../../core/Accessor.js";
import t from "../../core/Handles.js";
import { isNone as d } from "../../core/maybe.js";
import { react as r } from "../../core/reactiveUtils.js";
import { schedule as i } from "../../core/scheduling.js";
import { init as n, on as a } from "../../core/watchUtils.js";
import { valueOf as o } from "../../core/accessorSupport/get.js";
import { property as h } from "../../core/accessorSupport/decorators/property.js";
import { subclass as c } from "../../core/accessorSupport/decorators/subclass.js";

var l = /*#__PURE__*/function (_s) {
  _inherits(l, _s);

  var _super = _createSuper(l);

  function l() {
    var _this;

    _classCallCheck(this, l);

    _this = _super.apply(this, arguments), _this.updating = !1, _this.handleId = 0, _this.handles = new t(), _this.scheduleHandleId = 0, _this.pendingPromises = new Set();
    return _this;
  }

  _createClass(l, [{
    key: "destroy",
    value: function destroy() {
      this.removeAll(), this.handles.destroy();
    }
  }, {
    key: "add",
    value: function add(e, s, t) {
      var _this2 = this;

      var d = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : 0;
      var r = 0 != (1 & d),
          i = ++this.handleId;
      r || this.installSyncUpdatingWatch(e, s, i);
      var a = 0 != (2 & d) ? n(e, s, t, r) : e.watch(s, t, r);
      return this.handles.add(a, i), {
        remove: function remove() {
          return _this2.handles.remove(i);
        }
      };
    }
  }, {
    key: "addOnCollectionPropertyChange",
    value: function addOnCollectionPropertyChange(e, s, t) {
      var _this3 = this;

      var d = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : 0;
      var r = 0 != (2 & d),
          i = ++this.handleId;
      return this.handles.add([a(e, s, "after-changes", this.createSyncUpdatingCallback()), a(e, s, "change", t, r ? function (e) {
        t({
          added: e.items,
          removed: [],
          moved: [],
          target: e
        });
      } : void 0)], i), {
        remove: function remove() {
          _this3.handles.remove(i);
        }
      };
    }
  }, {
    key: "addOnCollectionChange",
    value: function addOnCollectionChange(e, s) {
      var _this4 = this;

      var t = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 0;
      var d = 0 != (2 & t),
          r = ++this.handleId;
      return this.handles.add([e.on("after-changes", this.createSyncUpdatingCallback()), e.on("change", s)], r), d && s({
        added: e.items,
        removed: [],
        moved: [],
        target: e
      }), {
        remove: function remove() {
          _this4.handles.remove(r);
        }
      };
    }
  }, {
    key: "addPromise",
    value: function addPromise(e) {
      var _this5 = this;

      if (d(e)) return e;
      var s = ++this.handleId;
      this.handles.add({
        remove: function remove() {
          _this5.pendingPromises.delete(e) && (0 !== _this5.pendingPromises.size || _this5.handles.has(m) || _this5._set("updating", !1));
        }
      }, s), this.pendingPromises.add(e), this._set("updating", !0);

      var t = function t() {
        return _this5.handles.remove(s);
      };

      return e.then(t, t), e;
    }
  }, {
    key: "removeAll",
    value: function removeAll() {
      this.pendingPromises.clear(), this.handles.removeAll(), this._set("updating", !1);
    }
  }, {
    key: "installSyncUpdatingWatch",
    value: function installSyncUpdatingWatch(e, s, t) {
      var d = this.createSyncUpdatingCallback(),
          i = r(function () {
        return o(e, s);
      }, d, {
        sync: !0,
        equals: function equals() {
          return !1;
        }
      });
      return this.handles.add(i, t), i;
    }
  }, {
    key: "createSyncUpdatingCallback",
    value: function createSyncUpdatingCallback() {
      var _this6 = this;

      return function () {
        _this6.handles.remove(m), ++_this6.scheduleHandleId;
        var e = _this6.scheduleHandleId;
        _this6._get("updating") || _this6._set("updating", !0), _this6.handles.add(i(function () {
          e === _this6.scheduleHandleId && (_this6._set("updating", _this6.pendingPromises.size > 0), _this6.handles.remove(m));
        }), m);
      };
    }
  }]);

  return l;
}(s);

e([h({
  readOnly: !0
})], l.prototype, "updating", void 0), l = e([c("esri.views.support.WatchUpdatingTracking")], l);
var m = -42;
export { l as WatchUpdatingTracking };